import SyntheseEnteteController from './synthese.entete.controller';

export default {
    controller: SyntheseEnteteController,
    template: require('./synthese.entete.tpl.html'),
    bindings: {
        model: '='
    }
};
